import {ThemeProvider, Container, Box, Typography,  CardContent, Button} from '@mui/material';

import { Link } from 'react-scroll';
import theme from "../../theme";

import { keyframes } from '@mui/material/styles';
import { useInView } from 'react-intersection-observer';


import iconBeeLeft from '../../assets/bee-left.svg';
import iconBeeRight from '../../assets/bee-right.svg';

const float = keyframes`
  0%   { transform: translateY(0px) rotate(0deg); }
  50%  { transform: translateY(-5px) rotate(2deg); }
  100% { transform: translateY(0px) rotate(0deg); }
`;

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;


const Banner = () => {

    const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.2 });
    const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.2 });
    const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.2 });

    return(

        <ThemeProvider theme={theme}>
            <Container maxWidth="xl"
                       sx={{
                           backgroundColor:'transparent',
                           marginTop:{ xs: 1, md: 10, lg: '40px' },
                           marginBottom: { xs: 1, md: 10, lg: '30px' },
                           maxHeight:'300px',
                           position: 'relative',
                           overflow: 'hidden',
                           minHeight: { xs: '250px', md: '350px', lg: '350px' },
                       }}>


                      <Box
                            component="img"
                            src={iconBeeLeft}
                            alt=""
                            aria-hidden="true"
                            sx={{
                              position: 'absolute',
                              height: { xs: '60px', sm: '80px', md: '100px' },
                              top: { xs: '0px', md: '0px' },
                              left: { xs: '5px', sm: '15px', md: '30px' },
                              animation: `${float} 6s ease-in-out infinite`,
                            }}
                          />

                          <Box
                            component="img"
                            src={iconBeeRight}
                            alt=""
                            aria-hidden="true"
                            sx={{
                              position: 'absolute',
                              height: { xs: '60px', sm: '80px', md: '100px' },
                              bottom: { xs: '20px', md: '50px' },
                              right: { xs: '10px', sm: '30px', md: '45px' },
                              animation: `${float} 5s ease-in-out infinite`,
                            }}
                          />

            <CardContent sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        position: 'relative',
                        zIndex: 1,
                      
                      }}>

                                <Box sx={{
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    pt:{ xs: '40px', sm:'50px', md: '80px' }
                                }}>

                                    <Typography variant="h2"  ref={ref1}
                                                sx={{
                                                    marginTop: { xs: '20px', md: '10px',lg:'10px', xl:'10px' },
                                                    fontSize: { xs: 22,sm:28, md: 40, xl:50 },
                                                    fontWeight: 700,
                                                    fontFamily: 'Caveat',
                                                    opacity: inView1 ? 1 : 0,
                                                    animation: inView1 ? `${fadeInUp} 1s ease-out forwards` : 'none',
                                                }}>
                                        Hobbystyczna pasieka zaprasza na miody prosto z pasieki!
                                    </Typography>

                                    <Typography variant="h2" ref={ref2}
                                        sx={{
                                        fontSize: { xs: 20,sm:25, md: 35, xl:45 },
                                        fontWeight: 600,
                                        fontFamily: 'Caveat',
                                        opacity: inView2 ? 1 : 0,
                                        animation: inView2 ? `${fadeInUp} 1.2s ease-out forwards` : 'none',
                                    }}>
                                        Poszukujesz prawidziwego miodu?
                                    </Typography>

                                <Link to ='contact' spy={true} smooth={true} style={{
                                                    textDecoration:'none',
                                                    color: 'black'
                                                }}>
                                                <Button  ref={ref3} sx={{
                                                    textTransform: 'none',
                                                    fontSize: { xs: 20,sm:25, md: 35, xl:45 },
                                                    fontWeight: 600,
                                                    fontFamily: 'Caveat',
                                                    opacity: inView3 ? 1 : 0,
                                                    animation: inView3 ? `${fadeInUp} 1.4s ease-out forwards` : 'none',
                                                }}>
                                      Skontaktuj się z nami!
                                          
                                                </Button>
                                </Link>
                            </Box>

               </CardContent>
            </Container >
        </ThemeProvider >
    )
}

export default Banner;